<template>
  <div>
    <div
      class="shimmer-overflow mt-2"
      :class="
        $route.name == 'AddCustomer' ||
        $route.name == 'EditCustomer' ||
        $route.name == 'ActivateCustomer' ||
        $route.name == 'Registration'
          ? 'p-0'
          : ''
      "
    >
      <b-row class="mt-5">
        <b-col
          v-for="(i, index) in shimmer"
          :key="index"
          :cols="index == 3 || index == 7 ? '9' : '4'"
          class="mb-4 shimmer"
        >
          <b-skeleton type="input"></b-skeleton>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "FormShimmer",
  data() {
    return {
      shimmer: 15,
    };
  },
};
</script>

<style></style>
